<template>
  <div>
    <transition name="el-fade-in-linear" mode="out-in">
      <div v-if="finished" key="END">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Order sent <span class="fa fa-check"></span></h3>
          </div>
          <div class="card-content row">
            <div class="col-sm-12">Your order for more credit has been sent to your account manager. You will be contacted by them shortly to complete your order.</div>
          </div>        
          <div class="card-footer">
          </div>
        </div> 
      </div>
      <div v-else key="START" class="row" v-loading="working" element-loading-spinner="qc-spinner">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Order Credits</h3>
            <p class="category">Please fill out this form to order more credits. You will be contacted for payment.</p>
          </div>
          <div class="card-content row">
            <div class="form-horizontal">
              <dynamic-input name="name" label="Name" placeholder="Name" v-model="name" :validations="{required:true}" />
              <dynamic-input name="email" label="Email" placeholder="Email" v-model="email" :validations="{required:true}" />
              <dynamic-input name="org" label="Organisation" placeholder="Organisation" v-model="org" :validations="{required:true}" />
              <dynamic-input name="department" label="Department / Faculty" placeholder="Department / Faculty" v-model="department" />
              
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Number of credits <span class="text-danger">*</span>
                </label>
                <div class="col-sm-10 form-control-static">
                  <el-input-number v-model="toBuy" :min="1" :max="1000"></el-input-number>
                </div>
              </div>
            </div>
          </div>        
        </div> 
        <div class="col-md-12 card card-plain">
          <button @click.prevent="pay" type="button" class="btn btn-wd btn-fill btn-move-right pull-right">Order <span class="btn-label"><i class="ti-angle-right"></i></span></button>
        </div>    
      </div>
    </transition>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'

  export default {
    name: "order-credit",
    components: {
      DynamicInput
    },
    data () {
      return { 
        finished: false,
        working: false,
        name: null,
        email: null,
        org: null,
        department: null,
        toBuy: 1
      }
    },
    mounted () {
      this.$api.getAccount()
        .then(response => {
          this.name = response.data.firstname + ' ' + response.data.lastname
          this.email = response.data.username
          this.org = response.data.institute ? response.data.institute.name : ''
        }).catch(error => {
          // Do nothing, who cares.
        })
    },
    methods: {
      pay () {
        this.working = true
        this.$api.postCreditOrder({
          name: this.name,
          email: this.email,
          org: this.org,
          department: this.department,
          toBuy: this.toBuy
        })
          .then(response => {
            this.working = false
            this.finished = true
          }).catch(error => {
            this.working = false
            this.$snotify.error("Your order has NOT been sent. Please try again or contact us for help.", "Error")
          })
      }
    }
  }
</script>